export default function Marquee({ items, reverse = false, speed = 30 }) {
  const doubled = [...items, ...items];
  return (
    <div style={{ overflow: 'hidden', borderTop: '1px solid var(--border)', borderBottom: '1px solid var(--border)', background: 'var(--bg2)', padding: '16px 0' }}>
      <div style={{
        display: 'flex', gap: '48px', width: 'max-content',
        animation: `marquee ${speed}s linear infinite ${reverse ? 'reverse' : ''}`,
      }}>
        {doubled.map((item, i) => (
          <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '48px', whiteSpace: 'nowrap' }}>
            <span style={{ fontFamily: 'Syne,sans-serif', fontSize: '15px', fontWeight: 600, color: i % 2 === 0 ? 'var(--text)' : 'var(--text2)' }}>
              {item}
            </span>
            <span style={{ color: 'var(--lime)', fontSize: '18px' }}>✦</span>
          </div>
        ))}
      </div>
    </div>
  );
}
